import axios from "axios";

/* Resolve the API base URL.
 *
 * In dev/preview the .env value is consumed verbatim.
 * In production we serve the SPA + the FastAPI under the same domain
 * (ingress routes /api/* to the backend pod), so the safest base is
 * the current page origin · that guarantees the auth cookie set by
 * /auth/login lands on the same domain the dashboard then calls.
 *
 * If REACT_APP_BACKEND_URL points to a different host than the page
 * we're running on, we fall back to window.location.origin to avoid
 * a cross-origin cookie scenario (SameSite=Lax would drop the cookie
 * on the cross-site fetch from the dashboard back to /auth/me). */
function resolveBackend() {
  const envUrl = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined") return envUrl;
  if (!envUrl) return window.location.origin;
  try {
    const envHost = new URL(envUrl).host;
    const pageHost = window.location.host;
    if (envHost !== pageHost) return window.location.origin;
  } catch (_e) {
    return window.location.origin;
  }
  return envUrl;
}

const BACKEND_URL = resolveBackend();
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  // Auth uses an httpOnly cookie set by the backend on /auth/login and
  // /auth/google/exchange. axios attaches it automatically when
  // withCredentials is true. The legacy localStorage Bearer fallback
  // has been removed (the migration to cookies has been complete for
  // several months) · this removes a small XSS exfiltration surface.
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
